module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/10x10-662c72a6103fc49a586ab6189833d95a.svg";